class SwiperGridSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const swiperCarousel = (sliderElm) => {
      if (
        sliderElm
          .querySelector('.swiper-wrapper')
          .getAttribute('data-enable-rotation') === 'false'
      ) {
        return new Swiper(sliderElm, {
          autoplay: false,
          freeMode: true,
          loop: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-enable-slides-loop')),
          navigation: {
            enabled: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-enable-slides-navigation')),
            nextEl: '[data-swiper-button-next]',
            prevEl: '[data-swiper-button-prev]'
          },
          slidesPerView: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-per-view-mobile')),
          spaceBetween: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-space-between-mobile')),
          breakpoints: {
            767: {
              slidesPerView: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-per-view')),
              spaceBetween: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-space-between'))
            },
            1024: {
              slidesPerView: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-per-view')),
              spaceBetween: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-space-between')),
              grabCursor: true
            }
          },
        });
      } else {
        return new Swiper(sliderElm, {
          autoplay: {
            delay: sliderElm.querySelector('.swiper-wrapper').getAttribute('data-rotation-delay'),
            pauseOnMouseEnter: true
          },
          speed: sliderElm.querySelector('.swiper-wrapper').getAttribute('data-rotation-speed'),
          freeMode: true,
          loop: true,
          navigation: {
            enabled: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-enable-slides-navigation')),
            nextEl: '[data-swiper-button-next]',
            prevEl: '[data-swiper-button-prev]'
          },
          slidesPerView: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-per-view-mobile')),
          spaceBetween: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-space-between-mobile')),
          breakpoints: {
            767: {
              slidesPerView: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-per-view')),
              spaceBetween: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-space-between'))
            },
            1024: {
              slidesPerView: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-per-view')),
              spaceBetween: JSON.parse(sliderElm.querySelector('.swiper-wrapper').getAttribute('data-slides-space-between')),
              grabCursor: true
            }
          }
        });
      }
    };

    this.allSliders = this.querySelectorAll('.swiper');
    this.allSliders.forEach((slider) => swiperCarousel(slider));
  }
}

if (!customElements.get('swiper-grid-slider')) {
  customElements.define('swiper-grid-slider', SwiperGridSlider);
}